import React from "react";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ls from "local-storage";
import Grid from "@mui/material/Grid";

const TOGGLE_VIEW = "TOGGLE_VIEW";
const LOAD_CACHE = "LOAD_CACHE";
const KEYWORDS_LIST_VIEW = "keywordsListView";
export const keywordsDefaultListView = {
  stock: true,
  stockLeft: true,
  cost: true,
  weight: true,
  minQuantity: true,
  maxQuantity: true,
  allowBackorder: false,
  allowInWeb: true,
  isActive: true,
  sku: false,
  detail: false,
  categories: false,
  variants: false,
  currencyCode: false,
  price: true,
  webPrice: false,
  vipTier: false,
  description: true,
  key: true,
  tieredPrices: true,
  webTieredPrices: false,
  createdAt: true,
  updatedAt: true,
};

const initialState = keywordsDefaultListView;
export const store = React.createContext(initialState);
const { Provider } = store;

export const StateProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer((state, action) => {
    switch (action.type) {
      case TOGGLE_VIEW:
        return {
          ...state,
          ...action.payload,
        };
      case LOAD_CACHE:
        return { ...action.payload };
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export const CustomDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle
    sx={{
      m: 0,
      p: 2,
      position: "relative",
    }}
    {...other}
  >
    <Typography>{children}</Typography>
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    ) : null}
  </DialogTitle>
);

const SelectableFields = () => {
  const [open, setOpen] = React.useState(false);
  const { state: listView, dispatch } = React.useContext(store);

  React.useEffect(() => {
    const cache = ls.get(KEYWORDS_LIST_VIEW);
    if (cache) {
      dispatch({ type: LOAD_CACHE, payload: cache });
    }
  }, [dispatch]);

  const onToggleHandler = React.useCallback(
    (e) => {
      dispatch({
        type: TOGGLE_VIEW,
        payload: { [e.target.name]: !listView[e.target.name] },
      });
    },
    [dispatch, listView]
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = React.useCallback(() => {
    setOpen(false);
    ls.set(KEYWORDS_LIST_VIEW, listView);
  }, [listView]);

  const keys = Object.keys(listView);

  const handleResetDefault = React.useCallback(() => {
    dispatch({
      type: LOAD_CACHE,
      payload: initialState,
    });
  }, [dispatch]);

  return (
    <>
      <Button color="primary" onClick={handleClickOpen}>
        <ViewColumnIcon />
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="list-selectable-dialog-title"
        open={open}
      >
        <CustomDialogTitle onClose={handleClose}>
          Customize List View
        </CustomDialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          <Grid
            container
            spacing={3}
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
            }}
            columns={{ xs: 3, md: 9 }}
          >
            {keys.map((k) => (
              <Grid size={{ xs: 3 }} key={k}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={listView[k]}
                      onChange={onToggleHandler}
                      name={k}
                      color="primary"
                    />
                  }
                  label={k}
                  sx={{
                    width: "100%",
                    mr: 0,
                    ".MuiTypography-root": { textTransform: "capitalize" },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetDefault}>Reset default</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectableFields;
